module.exports = __webpack_public_path__ + "img/1223826411.3d6c565b.jpg";